export default __webpack_public_path__ + "static/hap-b8b879401b3ffa4b6b367d0dfae926b9.jpg";